import PropTypes from 'prop-types';
import React from 'react';
import Button from '../../../Input/Button/Button';
import './PageNav.scss';

export default class PageNav extends React.Component {
    static propTypes = {
        /**
         * function to load previous page results
         */
        goToPrevPage: PropTypes.func,
        /**
         * function to load next page results
         */
        goToNextPage: PropTypes.func,
    };

    static defaultProps = {
        prevUrl: null,
        nextUrl: null,
    };

    render() {
        return (
            <div className="component-Management-Layout-PageNav">
                {PageNav.renderBtn('Prev', this.props.goToPrevPage)}
                {PageNav.renderBtn('Next', this.props.goToNextPage)}
            </div>
        );
    }

    static renderBtn(value, func) {
        if (!func) {
            return (
                <div className="page-btn d-inline-block">
                    <Button
                        disabled={true}
                        type="wired"
                        value={value}
                        qaAttr={`${value}-btn`}
                    />
                </div>
            );
        }

        return (
            <div className="page-btn d-inline-block">
                <Button
                    type="solid"
                    value={value}
                    onClick={func}
                    qaAttr={`${value}-btn`}
                />
            </div>
        );
    }
}
